import { atom } from 'recoil'

export type AuthState = {
  isAuthenticated: boolean
  email: string | null
  role: 'ADMIN' | 'USER' | null
}

const defaultAuthState: AuthState = {
  isAuthenticated: false,
  email: null,
  role: null
}

export const authAtom = atom<AuthState>({
  key: 'authAtom',
  default: defaultAuthState
})

export const isOnlineAtom = atom({
  key: 'isOnlineAtom',
  default: true
})
